import { render, staticRenderFns } from "./ManagerRequest.vue?vue&type=template&id=b6a3c376&"
import script from "./ManagerRequest.vue?vue&type=script&lang=js&"
export * from "./ManagerRequest.vue?vue&type=script&lang=js&"
import style0 from "./ManagerRequest.vue?vue&type=style&index=0&id=b6a3c376&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports